import { render, staticRenderFns } from "./AddGenerator.vue?vue&type=template&id=4cb8ba3c&"
import script from "./AddGenerator.vue?vue&type=script&lang=js&"
export * from "./AddGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports